export default __webpack_public_path__ + "3f893d70e5d28a862d2917082dc735d3.png";